export function getBackendBaseURL() {
  return `${import.meta.env.VITE_BACKEND_URL}/api`;
}

export function getBexaClinicalBaseURL() {
  return import.meta.env.VITE_BEXA_CLINICAL_SERVICES_URL;
}

interface IGetHeadersOptions {
  jwt?: string;
  metaData?: string;
}

export function getHeaders({
  jwt,
  metaData,
}: IGetHeadersOptions = {}): HeadersInit {
  const headers: HeadersInit = {
    'content-type': `application/json;charset=UTF-8${metaData ? metaData : ''}`,
  };

  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`;
  }

  return headers;
}
